import {AttrsSchema, Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {CohortGroupEntry, EntrySectionUpdateEvent, QueryEntry} from 'common/widgets/query-entry-section/types';
import {getEntryFromLiteral, getLiteralFromEntry} from 'common/report/util/cohorts/transformations/entries';

import {Literal} from '../models/builder/literal';
import {template} from './template';
import css from './index.styl?inline';

interface CohortsLiteralBuilderJsxProps {
  attrs: {
    'data-literal-idx'?: number;
    'data-draggable'?: boolean;
    disabled?: boolean;
    'user-id'?: number;
    'data-group-id'?: string;
    'project-id'?: number;
    'workspace-id'?: number;
    'project-as-of-date'?: string;
  };
  props?: {
    literal: Literal;
  };
}

interface CohortsLiteralBuilderState {
  entry: QueryEntry;
}

export class CohortsLiteralBuilder extends Component<
  CohortsLiteralBuilderState,
  CohortsLiteralBuilderJsxProps['attrs']
> {
  static get attrsSchema(): AttrsSchema<CohortsLiteralBuilderJsxProps['attrs']> {
    return {
      ...super.attrsSchema,
      disabled: {type: `boolean`, description: `whether this builder can be edited`},
      'user-id': `number`,
      'data-group-id': `string`,
      'project-id': `number`,
      'workspace-id': `number`,
      'project-as-of-date': {
        type: `string`,
        default: ``,
        description: `as of date for projects that do not have real time ingestion`,
      },
    };
  }

  get config() {
    return {
      css,
      template,
      useShadowDom: true,
      defaultState: {
        entry: null,
      },
      helpers: {
        handleSectionUpdate: ({detail: {entries}}: EntrySectionUpdateEvent) => {
          // const deletedEntry = ev.detail.entries.length === 0;
          if (entries.length === 0) {
            this.dispatchEvent(new CustomEvent(`delete`));
          } else {
            // query-entry-sections in this widget are single entry sections
            const literal = getLiteralFromEntry(entries[0] as CohortGroupEntry);
            this.dispatchEvent(new CustomEvent(`update`, {detail: {literal}}));
          }
        },
      },
    };
  }

  /** generates the selected entry from a given literal */
  set literal(literal: Literal) {
    this.update({entry: getEntryFromLiteral(literal, {literalIndex: 0, dataGroupId: ``}) as CohortGroupEntry});
  }
}

export const CohortsLiteralBuilderEl = defineAndMakeJsxFactory(`cohorts-literal-builder-new`, CohortsLiteralBuilder);
